import React, { useState,useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Button, Table, Tooltip, message } from "antd";
import { PartitionOutlined, PlusOutlined, PrinterOutlined } from "@ant-design/icons";
import axios from "axios";
import config from "../../config";
import dayjs from "dayjs";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

const PackgeDetails = () => {
    const [loading, setLoading] = useState(false);
    const[PackgeDetails,setPackgeDetails]= useState([]);
    const UserID = localStorage.getItem("ID");
    const AccessKey = localStorage.getItem("AccessKey");
    const PumpID = localStorage.getItem("PumpID");
 

    useEffect(() => {
      document.title="View Subscriptions"
        setLoading(true);
        const data = {
          UserID: UserID,
          AccessKey: AccessKey,
          PumpID: PumpID,
        };

        
        var api_config = {
          method: "post",
          url: config.base_url + "Members/GetPackagePurchaseByPumpID",
          header: {
            "Content-Type": "application/josn",
          },
          data: data,
        };
    
        axios(api_config)
          .then(function (response) {
            if (response.data.status_code == 1) {
                setPackgeDetails(response.data.listofRecords);
              setLoading(false);
            } else {
              // Handle error
              setLoading(false);
            }
            //   setLoading(false);
          })
          .catch(function (error) {
            message.error("Network Error");
            // console.log(error);
          });
      }, []);

      const columns = [
        {
          title: "Start Date",
          dataIndex: "StartDate",
          key: "startdate",
          render: (_, record) => dayjs(record.StartDate).format(config.date_format),
        },
        {
          title: "End Date",
          dataIndex: "EndDate",
          key: "EndDate",
          render: (_, record) => dayjs(record.EndDate).format(config.date_format),
        },
    
        {
          title: "Package",
          dataIndex: "PackageName",
          key: "PackageName",
        },
    
        {
          title: "Price",
          dataIndex: "PackagePrice",
          key: "PackagePrice",
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
           
            <div>
              <NavLink to={`/packge-details/invoice/${record.ID}`}>
                <Tooltip title="Print Invoice">
                  <PrinterOutlined />
                </Tooltip>
              </NavLink>
              </div>
           
          ),
        },
      ];

  return (
    <div className="right-side-contents">
      <div className="page-content">
        <div className="page-header">
        
          <h3 className="page-title">
          <NavLink to="/dashboard/analytics">
                <ChevronLeftIcon />
              </NavLink>
            Subscriptions</h3>
        </div>
        <Table
          size="small"
          scroll={{
            x: "max-content",
          }}
            loading={loading}
            dataSource={PackgeDetails}
            columns={columns}
          pagination={false}
          bordered
        />
      </div>
    </div>
  );
};

export default PackgeDetails;
